export let EKeysMap = /*#__PURE__*/function (EKeysMap) {
  EKeysMap["BACKSPACE"] = "Backspace";
  EKeysMap["DELETE"] = "Delete";
  return EKeysMap;
}({});